import { createContext, useContext, useMemo } from "react";
import { useQuery, useMutation } from "@tanstack/react-query";
import { getResidential, updateResidential } from "../../api/residential";
import { getIntialValues, generatePayload } from "./helper";
import useToaster from "../../components/alert";
import Const from "../../utils/constant";

const PageContext = createContext();

export const PageProvider = ({ children }) => {
  const toaster = useToaster();

  const getResidentialQuery = useQuery({
    queryKey: ["residential"],
    queryFn: getResidential,
  });

  const updateResidentialMutation = useMutation({
    mutationFn: updateResidential,
    onSuccess: () => {
      toaster.success(Const.MESSAGES.SUCCESS, Const.MESSAGES.DATA_IS_UPDATED_SUCCESSFULLY);
      getResidentialQuery.refetch();
    },
    onError: () => {
      toaster.error(Const.MESSAGES.FAILED, "Error updating Residential page.");
    },
  });

  const initialValues = useMemo(() => {
    const resData = getResidentialQuery?.data?.data || {};
    return getIntialValues(resData);
  }, [getResidentialQuery?.data]);

  const handleSubmit = (values) => {
    const payload = generatePayload(values);
    updateResidentialMutation.mutate(payload);
  };

  return (
    <PageContext.Provider
      value={{
        initialValues,
        handleSubmit,
        updateResidentialQuery: updateResidentialMutation,
      }}
    >
      {children}
    </PageContext.Provider>
  );
};

export const usePageProvider = () => {
  return useContext(PageContext);
};
